import * as ActionTypes from '../constants/ActionTypes';

const initialState = () => ({
    allReviews: {
        rows: [],
        paging: {}
    }
});

export default (state = initialState(), action) => {
    switch (action.type) {
        case ActionTypes.GET_ALL_REVIEWS:
            return {...state, allReviews: action.payload};
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/Reviews.js